import firebase from "firebase/app";
import "firebase/database";
import "firebase/storage"; // Add storage import

const firebaseConfig = {
  apiKey: "AIzaSyCsXjAVoF2tBSZE1h4ogZS7jofhhnIfPFw",
  authDomain: "uscomments-d65cb.firebaseapp.com",
  databaseURL: "https://uscomments-d65cb-default-rtdb.firebaseio.com",
  projectId: "uscomments-d65cb",
  storageBucket: "uscomments-d65cb.appspot.com",
  messagingSenderId: "1027673164819",
  appId: "1:1027673164819:web:d2ff40dc7df959bee103e6",
  measurementId: "G-7D4JK8D615",
};

const firstApp = firebase.initializeApp(firebaseConfig, "uscommentsApp");
const database = firstApp.database();
const storage = firstApp.storage(); // Initialize storage

const interactWithUSComments = async (method, path, value) => {
  let response = {
    data: null,
    status: "failed",
  };

  try {
    // Handle database operations
    if (
      method === "GET" ||
      method === "POST" ||
      method === "DEL" ||
      method === "PATCH"
    ) {
      const dbRef = database.ref(`${path}`);

      if (method === "GET") {
        const snapshot = await dbRef.once("value");
        if (snapshot.exists()) {
          response = {
            data: snapshot.val(),
            status: "Success",
          };
        } else {
          response.status = "No data found";
        }
      } else if (method === "POST") {
        await dbRef.set(value); // Overwrites data at the path
        response = {
          data: value,
          status: "Success",
        };
      } else if (method === "PATCH") {
        await dbRef.update(value); // Updates only specified fields
        response = {
          data: value,
          status: "Success",
        };
      } else if (method === "DEL") {
        await dbRef.remove();
        response = {
          data: null,
          status: "Deleted",
        };
      }
    }
    // Handle single image upload operation
    else if (method === "UPLOAD_IMAGE") {
      // path should be the storage path
      // value should be the blob or file to upload
      const storageRef = storage.ref();
      const imageRef = storageRef.child(path);

      // Start the upload
      const uploadTask = await imageRef.put(value);

      // Get the download URL
      const downloadURL = await uploadTask.ref.getDownloadURL();

      response = {
        data: downloadURL,
        status: "Success",
      };
    }
    // Handle batch image uploads in parallel
    else if (method === "UPLOAD_IMAGES_BATCH") {
      // path should be the base storage path
      // value should be an array of { id, file } objects

      if (!Array.isArray(value)) {
        throw new Error("Batch upload requires an array of image objects");
      }

      const storageRef = storage.ref();
      const uploadPromises = value.map(async (imageObj, index) => {
        try {
          const uniquePath = `${path}/${index}_${Date.now()}_${
            imageObj.id || "image"
          }`;
          const imageRef = storageRef.child(uniquePath);

          // Upload the image
          const uploadTask = await imageRef.put(imageObj.file);

          // Get the download URL
          const downloadURL = await uploadTask.ref.getDownloadURL();

          return {
            id: imageObj.id,
            url: downloadURL,
          };
        } catch (error) {
          console.error("Error uploading image:", error);
          return null; // Return null for failed uploads
        }
      });

      // Wait for all uploads to complete in parallel
      const results = await Promise.all(uploadPromises);

      // Filter out failed uploads
      const successfulUploads = results.filter(Boolean);

      response = {
        data: successfulUploads,
        status: successfulUploads.length > 0 ? "Success" : "Failed",
        totalUploaded: successfulUploads.length,
        totalAttempted: value.length,
      };
    }
    // Handle file deletion from storage
    else if (method === "DELETE_IMAGE") {
      // path should be the storage path of the image to delete
      const storageRef = storage.ref();
      const imageRef = storageRef.child(path);

      await imageRef.delete();

      response = {
        data: null,
        status: "Success",
      };
    } else {
      response.status = "Invalid method";
    }
  } catch (error) {
    console.error("Firebase interaction error:", error);
    response = {
      status: "Error",
      message: error.message,
      error: error,
    };
  }

  return response;
};

export default interactWithUSComments;
